/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Users_TitleInputs */

const es_walkthrough_admin_users_title = /** @type {(inputs: Walkthrough_Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de Usuarios`)
};

const en_walkthrough_admin_users_title = /** @type {(inputs: Walkthrough_Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Management`)
};

/**
* | output |
* | --- |
* | "User Management" |
*
* @param {Walkthrough_Admin_Users_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_users_title = /** @type {((inputs?: Walkthrough_Admin_Users_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Users_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_users_title(inputs)
	return en_walkthrough_admin_users_title(inputs)
});
export { walkthrough_admin_users_title as "walkthrough.admin_users_title" }